var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionRelock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46755 7.53414V6.62087C7.46755 5.8643 8.08088 5.25098 8.83745 5.25098C9.59402 5.25098 10.2073 5.8643 10.2073 6.62087V7.99077M7.01092 12.5571H10.664C11.1684 12.5571 11.5772 12.1482 11.5772 11.6438V8.90404C11.5772 8.39965 11.1684 7.99077 10.664 7.99077H7.01092C6.50654 7.99077 6.09766 8.39965 6.09766 8.90404V11.6438C6.09766 12.1482 6.50654 12.5571 7.01092 12.5571Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99972 16.3677C2.60868 14.9827 1 12.3939 1 9.42893C1 6.06718 3.06803 3.18911 5.99965 2.00079M5.99965 13.9348L5.99965 17.94H1.99993M12.9992 2.5723C15.3902 3.95734 16.9989 6.54608 16.9989 9.51107C16.9989 12.8728 14.9309 15.7509 11.9992 16.9392M11.9992 5.00521V0.999998L15.999 0.999998",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRelock);
export default __webpack_public_path__ + "static/media/action-relock.c8354f72f6712a7cb1c977496c872a43.svg";
export { ForwardRef as ReactComponent };